import React, { useState } from 'react';
import CommonTable from './commonTable';

const LanguageList = ({ data, page, setPage, onEdit, onDelete, setSearchTerm, onFilter }) => {
  const columns = [
    { header: 'ID', accessor: '_id' },
    { header: 'Language Name', accessor: 'languageName' },
    { header: 'Status', accessor: 'status' },
    { header: 'Default', accessor: 'default' },
    {
      header: 'Operate',
      render: (row) => (
        <div className="flex gap-2">
          <button
            className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
            onClick={() => onEdit(row)}
            title="Edit"
          >
            <i className="fas fa-edit"></i>
          </button>
          <button
            className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
            title="Delete"
            onClick={() => onDelete(row._id)} // Assuming onDelete is defined to handle deletion
          >
            <i className="fas fa-trash-alt"></i>
          </button>
        </div>
      )
    }
  ];
  const handlePagination = (page) => {
    console.log('Page changed to:', page);
    setPage(page);
    // Implement pagination logic here if needed
  };
  const handleRefresh = () => {
    if (onFilter) {
      onFilter({});
    }
  };
  const handleSearch = (searchTerm) => {
    onFilter({ search: searchTerm });
  };
  return (
    <div>
      <div className="bg-white rounded-lg shadow p-6 m-4">
        {/* Header */}
        <div className="mb-2">
          <span className="text-2xl font-bold text-black-600">Languages</span>
        </div>
        <hr className="mb-6" />

        {/* Search and actions */}
        <div className="flex justify-end items-center gap-2 mt-4 mb-6">
          <input
            type="text"
            placeholder="Search"
            onChange={(e) => {
              const timeoutId = setTimeout(() => {
                onFilter({ search: e.target.value });
              }, 500); // 500ms delay

              return () => clearTimeout(timeoutId);
            }}
            className="input-company w-full sm:w-1/3"
          />
          <div className="flex gap-1">
            <button
              onClick={handleRefresh}
              className="btn-primary"
            >
              {/* Refresh Icon */}
              <i className="fas fa-sync"></i>
            </button>
          </div>
        </div>
        <CommonTable
          columns={columns}
          data={data}
          pagination={true}
          currentPage={page} // Assuming you want to start from page 1
          totalItems={data?.meta?.pagination?.totalItems}
          onPageChange={handlePagination}
        />
      </div>
    </div>
  );
};

export default LanguageList;
